import api from "./api";

export const getTags = async () => {
  return await api.get("/tags");
};

export const addTag = async (name) => {
  return await api.post("/tags",{name});
};